import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/FeatureAdd";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { GeoNames } from "esdm-map/dist/gazetteer/geonames";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";
import { IVectorLayerGroup } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroup";
import { ZoomToDataBounds } from "esdm-map/dist/layers/vector/ZoomToDataBounds";
import { VectorLayerStrategy } from "esdm-map/dist/layers/vector/VectorLayerStrategy";
import { CustomMapLayerSwitcherOverlays } from "./CustomMapLayerSwitcherOverlays";
import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    MiniMapsForLists,
    BaseLayerType,

    MapFeatureInfo
} from "esdm-map";

import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { KentRecordType, KentRecordSubType } from "./KentRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { TextPackLoader, TextPacks } from "./TextPackLoader";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import { HbsmrUser, HbsmrIdentity } from "./HbsmrUser";
import { MapBase } from "./MapBase";
import { IWmsLayerGroupConfig, IWmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms/interfaces";
import { WmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms";

import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { KentBaseLayerTypes, KentBaseMapping_27700 } from "./KentBaseMapping_27700";
import { MapToolTip, ToolTipOptions } from "esdm-map/dist/map/tooltip";

import { Popover } from "bootstrap";
import { debounce } from "debounce";

import "../wwwroot/css/bootstrap-select.css"
import "../wwwroot/css/ol-contextmenu.css";

$(document).ready(function () {
    //selectPicker
    (<any>$('.hbsmrSelectPicker')).selectpicker({
        noneSelectedText: "",
        "selected-text-format": "count > 1"
    });

    $('.hbsmrSelectPicker').on('loaded.bs.select', function (e) {
        var name = $(this).attr("name").replace(/([A-Z])/g, ' $1').trim();
        $(this).next(".btn").append("<span class='visually-hidden'>" + name + "</span>");
    });

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl, {
            html: true,
            trigger: 'focus',
            content: function () {
                var content = $(this).attr("data-popover-content");
                return $(content).children(".popover-body").html();
            }
        })
    })

    let didLoadMap = false;
    let ele = $("#theMap");
    let maxFeatureCount: number = <number>ele.data("max-feature-count");
    console.log("maxFeatureCount:" + maxFeatureCount);

    let data = $("#searchMapData");
    let searchOptions: IMonumentSearch = {
        searchString: <string>data.data("search-string"),
        searchMode: <string>data.data("search-mode"),
        recordType: <string>data.data("record-type"),
        monType: <string>data.data("mon-type"),
        objectType: <string>data.data("object-type"),
        adminArea: <string>data.data("admin-area"),
        periodFrom: <string>data.data("period-from"),
        periodTo: <string>data.data("period-to"),
        periodIncludeOverlaps: <string>data.data("period-overlaps")
    };

    let printOptions: PrintMap = new PrintMap();


    function addHandlers() {
        $(".scrollTo").click(function (e) {
            let id = $(this).data("scrollto");
            if (id) {
                $('html, body').animate({
                    scrollTop: ($(id).offset().top)
                }, 500);
            }
            e.preventDefault();
        });
    }
    addHandlers();


    function resizeMap() {
        //use max footer height, especially on mobile
        //var fHeight = $("footer").height();
        //fHeight = Math.min(fHeight, 200);

        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
    };

    let loadMap = function () {
        HbsmrIdentity.fetch().then(function (e) {
            let user = e;
            let init = function (textpacks: TextPacks) {
                resizeMap();
                window.addEventListener('resize', debounce(resizeMap, 250));  
                let map = new MonumentSearchMap("theMap", searchOptions, maxFeatureCount, printOptions, textpacks.mapping, user);
                didLoadMap = true;
            }
            TextPackLoader.load().then(init);
        });
    }

    if (printOptions.isPrintMap) {
        loadMap();
    }
    else {
        let bingAPIKey: string = ele.data("bing-api-key");
        let esdmOsmApiKey: string = ele.data("esdm-osm-api-key");
        let baseLayerFactory: IBaseLayerFactory = new KentBaseMapping_27700();
        let miniMaps = new MiniMapsForLists(KentBaseLayerTypes.KentOS, bingAPIKey, esdmOsmApiKey, baseLayerFactory, "EPSG:27700", "EPSG:27700");

        //only show the map when the map tab is visible
        $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
            let target = $(e.target).attr("href") // activated tab
            if (target === "#tabMap") {
                if (didLoadMap === false) {
                    loadMap();
                }
            } else if (target === "#tabList" && didLoadMap === true) {
                // If the map has loaded it means the user has visited the 'Map' tab, they could have possibly also put the map into fullscreen mode
                // if they have then we need to redraw/refresh the miniMaps on the search results list, as they don't refresh correctly after exiting
                // the fullscreen mode
                miniMaps.refreshMiniMaps();
            }
        });
    }
});

export interface IMonumentSearch {
    searchString: string;
    searchMode: string;
    recordType: string;
    monType: string;
    objectType: string;
    adminArea: string;
    periodFrom: string;
    periodTo: string;
    periodIncludeOverlaps: string;
}

export class MonumentSearchMap extends MapBase {

    private map: IMap;
    private mfOptions: MapOptions;
    private mapStore: IMapViewStore;
    private styleFactory: IStyleFactory;
    private ls: MapLayerSwitcher;
    private vectorLayerGroups: Array<IVectorLayerGroup>;
    private infoPopup: MapFeatureInfo;
    private initialised = false;
    private herMask: IMapAreaMask;
    private geoNames: GeoNames;
    private logger: ILogger;
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private wmsLayerGroupFactory: IWmsLayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;
    private downloadPng: DownloadMapPng;
    private extentsNavigation: ExtentsNavigation;
    private gridRefFinder: GridRef;
    private mousePosition: MousePosition;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private layerGroups: LayerGroupCollections;
    private layerGroupFactory: LayerGroupFactory;
    private mapToolTip: MapToolTip;

    constructor(
        private _mapElementId: string,
        private _searchOptions: IMonumentSearch,
        private _maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: HbsmrUser) {
        super(mappingTextPack, user);
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }

        $("#printButton").hide();
        $("#slide-panel-btn-tools").hide();

        this.layerConfigFactory = new DefaultLayerConfigurationFactory();
        this.wmsLayerGroupFactory = new WmsLayerGroupFactory();
        this.vectorLayerGroupFactory = new VectorLayerGroupFactory();
        this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, this.wmsLayerGroupFactory);
        this.mapFilter = new MapFilters();
        this.mapFilter.OgcFilter = new OgcMapFilter();
        this.baseLayerFactory = new KentBaseMapping_27700();
        this.featureLoader = new GeoJsonFeatureLoader();
        this.featureAdd = new FeatureAddSmallGeomsAsPoint(4.5);
        this.mapFactory = new MapFactory();
        this.logger = new Logger();
        this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
        this.styleFactory = new HbsmrStyleFactory();
        this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

        this.mfOptions = DefaultMapOptions.GetDefaultOptions(this._mapElementId, "MonumentSearchMap27700");
        this.mfOptions.enableBoundsTracking = false;
        //zoom & centre determines the start position of the map
        this.mfOptions.mapZoom = 7;
        //this.mfOptions.mapCentre = [591525, 147225];

        this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
        this.mfOptions.layerGroupCollection = this.layerGroups;


        this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey);
        //don't remember the layers if this is the first page of the search
        if ($("#MapPageNumber").val() == 1) {
            this.mapStore.clear()
        }        

        this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
        this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
        this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);
        this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);
        let overlays = new CustomMapLayerSwitcherOverlays(this.map, this.mapStore, this.layerGroups, this.mappingTextPack);
        this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, overlays, {
            showList: false,
            showOpenPanelByDefault: !this.printOptions.isPrintMap,
            rememberActivePanel: true
        });

        this.geoNames = new GeoNames(this.map, this.mappingTextPack);

        if (this.printOptions.isPrintMap) {
            this.printOptions.setMap(this.map);
        }
        //this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
        this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
        this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
        this.mousePosition = new MousePosition(this.map, this.mappingTextPack);

        if (!('ontouchstart' in window && navigator.maxTouchPoints > 0)) {
            //add tooltip if not touch
            this.mapToolTip = new MapToolTip(this.map, new ToolTipProvider(), new ToolTipOptions(7));
        }

        this.initialised = true;
    }

    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {
        let self = this;

        let monSearchLayers = [
            /*{
                layerName: "MonumentPolygonsWFS",
                minZoom: 8,
                maxZoom: 19
            },
            {
                layerName: "MonumentLinesWFS",
                minZoom: 1,
                maxZoom: 19
            },*/
            {
                layerName: "MonumentPointsWFS",
                minZoom: 1,
                maxZoom: 19
            }
        ]

        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            self.layerConfigFactory.layerConfig(KentRecordType.Monument, null, { layers: monSearchLayers }),
            self.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ListedBuilding),
            self.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ScheduledMonument),
            self.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.RegisteredParksAndGardens),
            self.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.HistoricParksAndGardens),
            self.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ConservationArea),
            self.layerConfigFactory.layerConfig(KentRecordType.HistoricLandscapeCharacterisation)
        ];


        let hasFilter = (self._searchOptions.monType || self._searchOptions.objectType || self._searchOptions.adminArea || self._searchOptions.periodFrom || self._searchOptions.periodTo);

        //only use the search layer if we have any filters
        if (hasFilter) {
            layerGroupConfig.forEach(function (layer: IVectorLayerGroupConfig, index: number) {
                if (layer.type === self._searchOptions.recordType) {
                    layer.displayName = layer.displayName + ' <i class="fas fa-filter"></i>',
                        layer.layers.forEach(l => { l.layerName += "_StructuredSearch" });
                    layer.zoomToDataBounds = ZoomToDataBounds.Always;
                    layer.strategy = VectorLayerStrategy.Bbox;
                    layer.allowZoomToLoadedDataBounds = false;
                    layer.visibleOnLoad = true;
                    layer.maxFeatureCount = self._maxFeatureCount;
                    layer.useWfsBboxRequestParameter = true;
                    layer.urlParams = {
                        ...{
                            monTypeTerm: self._searchOptions.monType,
                            findTypeTerm: self._searchOptions.objectType,
                            adminArea: self._searchOptions.adminArea,
                            period1: self._searchOptions.periodFrom,
                            period2: self._searchOptions.periodTo,
                            periodIncludeOverlaps: self._searchOptions.periodIncludeOverlaps,
                            maxFeatureCount: self._maxFeatureCount
                        }, ...layer.urlParams
                    }
                }
            });
        }

        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: self.filterMapLayers(layerGroupConfig)
            }
        ];
    }

}
